// src/pages/Dashboard/Establecimiento/PublicacionNotas.jsx
import React, { useState, useEffect } from 'react';
import { Card, message, Typography, Button, Input, Spin, Row, Col, Alert } from 'antd';
import { CalendarOutlined, SaveOutlined, InfoCircleOutlined } from '@ant-design/icons';
import apiClient from '../../../api/apiClient';

const { Title, Text } = Typography;

const UNIDADES = [1, 2, 3, 4];
const clave = (n) => `FECHA_PUBLICACION_UNIDAD_${n}`;
const hoy = () => new Date().toLocaleDateString('en-CA', { timeZone: 'America/Guatemala' });

const PublicacionNotas = () => {
  const [loading, setLoading] = useState(false);
  const [guardando, setGuardando] = useState(null);
  const [fechas, setFechas] = useState({});
  const [existentes, setExistentes] = useState({});

  useEffect(() => {
    cargar();
  }, []);

  const cargar = async () => {
    setLoading(true);
    try {
      const res = await apiClient.get('/configuraciones');
      const mapa = {};
      (res.data.data || []).forEach(c => { mapa[c.Clave] = c.Valor; });
      setExistentes(mapa);
      setFechas(mapa);
    } catch (err) {
      message.error('Error al cargar las fechas de publicación');
    } finally {
      setLoading(false);
    }
  };

  const handleGuardar = async (n) => {
    const valor = fechas[clave(n)];
    if (!valor) {
      message.warning('Seleccione una fecha');
      return;
    }
    const user = JSON.parse(localStorage.getItem('user') || '{}');
    setGuardando(n);
    try {
      await apiClient.put(`/configuraciones/${clave(n)}`, { Valor: valor, ModificadoPor: user.IdUsuario });
      message.success(`Fecha de la Unidad ${n} guardada`);
      await cargar();
    } catch (err) {
      message.error(err.response?.data?.error || 'Error al guardar la fecha');
    } finally {
      setGuardando(null);
    }
  };

  if (loading) {
    return (
      <div style={{ padding: 24, textAlign: 'center' }}>
        <Spin size="large" />
      </div>
    );
  }

  return (
    <div style={{ padding: 24 }}>
      <Title level={2}>
        <CalendarOutlined /> Publicación de Notas
      </Title>

      <Alert
        type="info"
        icon={<InfoCircleOutlined />}
        showIcon
        style={{ marginBottom: 24 }}
        message="¿Cómo funciona?"
        description="Padres de familia y estudiantes no ven la nota final ni los punteos de las actividades de una unidad hasta la fecha indicada (desde ese día ya se ven). Administradores y docentes siempre ven todo."
      />

      <Row gutter={[24, 24]}>
        {UNIDADES.map(n => {
          const existe = existentes[clave(n)] !== undefined;
          const valor = fechas[clave(n)] || '';
          const bloqueada = valor && hoy() < valor;
          return (
            <Col xs={24} md={12} lg={6} key={n}>
              <Card title={`Unidad ${n}`} style={{ borderTop: `4px solid ${bloqueada ? '#ff4d4f' : '#52c41a'}` }}>
                <Text type={bloqueada ? 'danger' : 'success'} style={{ display: 'block', marginBottom: 12 }}>
                  {bloqueada ? '🔒 Oculta para padres y estudiantes' : '✅ Visible'}
                </Text>
                <Input
                  type="date"
                  value={valor}
                  onChange={(e) => setFechas(prev => ({ ...prev, [clave(n)]: e.target.value }))}
                  disabled={!existe}
                  size="large"
                  style={{ marginBottom: 16 }}
                />
                <Button
                  type="primary"
                  icon={<SaveOutlined />}
                  onClick={() => handleGuardar(n)}
                  loading={guardando === n}
                  disabled={!existe}
                  block
                >
                  Guardar
                </Button>
              </Card>
            </Col>
          );
        })}
      </Row>
    </div>
  );
};

export default PublicacionNotas;
